<template>
  <section class="projects-section">
    <VueSlickCarousel v-if="projects" v-bind="carouselSettings">
      <div v-for="(prj, idx) in projects" :key="idx" @click="() => showModal(prj.youtube_link)" class="project-card text-left">
        <img class="project-thumbnail" :src="prj.project_thumbnail.startsWith('https://images.avishkaar.cc') ? prj.project_thumbnail : `https://avishkaar-users.s3.amazonaws.com/${prj.project_thumbnail}`" alt="Project Thumbnail">
        <img v-if="prj.profile_img && prj.profile_img !== '0'" class="project-profile" :src="prj.profile_img" alt="User Profile Picture">
        <img v-else class="project-profile" src="https://images.avishkaar.cc/user-placeholder.png" alt="Default User Profile Picture">
      </div>
    </VueSlickCarousel>
    <b-modal ref="modal-prj" hide-header hide-footer>
      <div class="modal-box">
        <div class="p-3 text-center">
          <iframe v-if="ytLink" width="100%" height="315" :src="`https://www.youtube.com/embed/${ytLink}`" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          <div v-else>
            Project video not found.
          </div>
        </div>
        <button @click="closeModal" class="close-button">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </b-modal>

  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

export default {
  name: "ProjectsSection",
  props: ["projects"],
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      ytLink: false,
      carouselSettings: {
        arrows: true,
        dots: false,
        slidesToShow: 4,
        focusOnSelect: false,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 576,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              arrows: false,
              dots: true,
              infinite: true,
              focusOnSelect: true,
            }
          },
        ]
      }
    }
  },
  methods: {
    showModal(ytl) {
      if (ytl.indexOf('.be/') != -1) this.ytLink = ytl.split('.be/')[1];
      else if (ytl.indexOf('?v=') != -1) this.ytLink = ytl.split('?v=')[1];
      else if (ytl.indexOf('/v/') != -1) this.ytLink = ytl.split('/v/')[1];
      else if(ytl.indexOf('embed/') != -1) this.ytLink = ytl.split('embed/')[1];
      else if(ytl.indexOf('shorts/') != -1) this.ytLink = ytl.split('shorts/')[1];
      else this.ytLink = false;
      // this.ytLink = ytl.split('?v=')[1];
      this.$refs['modal-prj'].show();
    },
    closeModal() {
      this.$refs['modal-prj'].hide();
    }
  }
}
</script>

<style scoped>
/* projects section card */
.project-card {
  position: relative;
  width: 230px !important;
  height: 203px;
  cursor: pointer;
  overflow: hidden;
}

/* give 0 opacity to carousel overlay */
.slick-active {
  opacity: 0 !important;
}

/* thumbnail image on the back */
.project-card > .project-thumbnail {
  position: absolute;
  top: 0;
  left: 0;
  width: 92%;
  height: 92%;
  border-radius: 4px;
}

/* profile picture on top of thumbnail image */
.project-card > .project-profile {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 2;
  height: 104px;
  width: 104px;
  border-radius: 1000px;
}

/* overlay box with position-relative to dsplay close button on top right with position-absolute */
.modal-box {
  position: relative;
  width: 100%;
  height: 100%;
}

.modal-box > .close-button {
  position: absolute;
  top: -15px;
  right: -15px;
  background-color: #d2691e;

  height: 30px;
  width: 30px;
  border: none;
  border-radius: 1000px;
}
/* .modal-box > .close-button:focus {
  border: none;
} */
</style>

<style>
.projects-section .slick-active {
  opacity: 1;
}
</style>